/**
 * useReducedMotion — Detects user preference for reduced motion.
 *
 * Returns true when the user's OS/browser has `prefers-reduced-motion: reduce`
 * enabled. Used by <MyWorkLane> to suppress swimlane fade transitions (NFR-010).
 */
import { useState, useEffect } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

export function useReducedMotion(): boolean {
  const [prefersReduced, setPrefersReduced] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setPrefersReduced(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return prefersReduced;
}
